/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1682
 */

"use strict"

var r = require(/* 1086 */"./1086")
var o = require(/* 836 */"../1282/836")
module.exports = r ? {}.toString : function () {
  return "[object " + o(this) + "]"
}
